/**
 * Cache des dimensions canvas des blocs (pixels natifs de l’image servie).
 * Clé composite blocId + updated_at : évite les dimensions périmées en session après
 * régénération d’assets alors que le même id de bloc existe toujours.
 */
const STORAGE_KEY = 'cuxa-block-dimensions-canvas-v3';

const memory = new Map<string, { width: number; height: number }>();

function compositeKey(blocId: number, updatedAt?: string | null): string {
  return `${blocId}::${updatedAt ?? ''}`;
}

function loadFromStorage(): void {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    const data = JSON.parse(raw) as Record<string, { width: number; height: number }>;
    Object.entries(data).forEach(([k, v]) => memory.set(k, v));
  } catch {
    // ignore
  }
}

let storageLoaded = false;

export function useBlockDimensionsCache() {
  function get(
    blocId: number | null | undefined,
    updatedAt?: string | null
  ): { width: number; height: number } | undefined {
    if (blocId == null) return undefined;
    if (!storageLoaded) {
      loadFromStorage();
      storageLoaded = true;
    }
    return memory.get(compositeKey(blocId, updatedAt));
  }

  function set(
    blocId: number,
    updatedAt: string | undefined | null,
    width: number,
    height: number
  ): void {
    memory.set(compositeKey(blocId, updatedAt), { width, height });
    try {
      const flat: Record<string, { width: number; height: number }> = {};
      memory.forEach((v, mapKey) => {
        flat[mapKey] = v;
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(flat));
    } catch {
      // ignore
    }
  }

  return { get, set };
}
